import { registerEdgeType } from '../services/EdgeTypeRegistry';
import { getShape, getLineLength } from '@/modules/Node';
import type { EdgeTypeDefinition, EdgeBoundsContext, EdgeLineBounds } from '../types/EdgeTypes';
import type { EdgeData } from '@/modules/Node';

function createPath(
  ctx: CanvasRenderingContext2D,
  startX: number,
  startY: number,
  endX: number,
  endY: number
): void {
  ctx.moveTo(startX, startY);
  ctx.lineTo(endX, endY);
}

function calculateLineBounds(context: EdgeBoundsContext): EdgeLineBounds {
  if (context.name) {
    return { width: context._BASE_CANVAS_SIZE, height: context.borderWidth, x: 0, y: 0 };
  }

  const edgeComputedHeight = context.editing
    ? context.borderWidth + context._HOVER_AREA
    : context.borderWidth;

  const fromShapeDef = getShape(context.fromNodeShape);
  const toShapeDef = getShape(context.toNodeShape);

  const fromPoint = fromShapeDef.getEdgeConnectionPoint(context as unknown as EdgeData, 'from');
  const toPoint = toShapeDef.getEdgeConnectionPoint(context as unknown as EdgeData, 'to');

  const width = getLineLength(fromPoint.x, toPoint.x, fromPoint.y, toPoint.y);

  return { width, height: edgeComputedHeight, x: 0, y: 0 };
}

const straightEdgeType: EdgeTypeDefinition = {
  value: 'straight',
  createPath,
  calculateLineBounds,
};

registerEdgeType(straightEdgeType);

export { straightEdgeType };
